import { useEffect } from 'react'

interface UsePopStateEventListenerProps {
  onPopState?: (event: PopStateEvent) => void
}
const usePopStateEventListener = ({ onPopState }: UsePopStateEventListenerProps) => {
  const enabled = !!onPopState
  useEffect(() => {
    if (!enabled) return
    window.history.pushState(null, '', window.location.href)
    // 현재 URL을 history stack에 추가
    const handlePopState = (event: PopStateEvent) => {
      window.history.go(1)
      onPopState?.(event)
    }
    window.addEventListener('popstate', handlePopState)
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [enabled, onPopState])
}

export default usePopStateEventListener
